export default __webpack_public_path__ + "static/media/photo-content-decor-1.2ae78e58.svg";